import React, { useState } from "react";
import "./faq.css";
import useIntersectionObserver from "../customHooks/useIntersectionObserver";

export default function FAQ() {
  const [activeIndex, setActiveIndex] = useState(null);
  const faqData = [
    {
      question: "What is SAIF Aviator?",
      answer:
        "SAIF Aviator is a comprehensive implementation of Google's Secure AI Framework (SAIF), designed to assess, protect, and monitor AI systems throughout their lifecycle with automated security controls and continuous risk management.",
    },
    {
      question: "How does SAIF Aviator protect AI systems?",
      answer:
        "SAIF Aviator provides multi-layered protection by implementing security controls across data, infrastructure, models, and applications, while continuously monitoring for threats and automatically responding to security incidents.",
    },
    {
      question: "What industries can benefit from SAIF Aviator?",
      answer:
        "SAIF Aviator serves industries including Financial Services, Healthcare, Manufacturing, Retail, and Telecommunications, providing tailored security solutions for each sector's specific AI security challenges.",
    },
    {
      question: "How does SAIF Aviator help with compliance?",
      answer:
        "SAIF Aviator automates compliance verification across multiple regulatory standards, providing documentation, control implementation, and continuous monitoring to simplify compliance management.",
    },
    {
      question: "What role does automation play in SAIF Aviator?",
      answer:
        "Automation is central to SAIF Aviator, enabling continuous security monitoring, threat detection, incident response, and compliance verification without increasing operational overhead.",
    },
    {
      question:
        "How does SAIF Aviator differ from traditional security solutions?",
      answer:
        "SAIF Aviator is specifically designed for AI systems, addressing unique challenges like model security, data poisoning, prompt injection, and other AI-specific threats that traditional security solutions aren't equipped to handle.",
    },
    {
      question:
        "Can SAIF Aviator integrate with existing security infrastructure?",
      answer:
        "Yes, SAIF Aviator is designed to integrate seamlessly with existing security platforms, extending protection to AI systems while maintaining consistent security protocols across your organization.",
    },
    {
      question: "How quickly can SAIF Aviator be implemented?",
      answer:
        "Implementation timelines vary based on organizational complexity, but SAIF Aviator is designed for modular deployment, allowing critical components to be implemented within weeks rather than months.",
    },
  ];

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
  const [ref, isVisible] = useIntersectionObserver({ threshold: 0.25 });

  return (
    <section
      className={`faq-section ${isVisible ? "section-animation" : ""}`}
      ref={ref}
      id="six"
    >
      <div className="container">
        <div className="section-heading">
          <div className="heading-tag">
            <span>FAQ</span>
          </div>
          <div className="heading-description">
            <h2>Frequently Asked Questions</h2>
            <p>Everything you need to know</p>
          </div>
        </div>

        <div className="accordion">
          {faqData.map((item, index) => (
            <div className="accordion-item" key={index}>
              <button
                id={`accordion-button-${index + 1}`}
                aria-expanded={activeIndex === index ? "true" : "false"}
                onClick={() => toggleAccordion(index)}
              >
                <span className="accordion-title">{item.question}</span>
                <span className="icon" aria-hidden="true"></span>
              </button>
              <div className="accordion-content">
                <p>{item.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
